import { Component, OnDestroy, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ImportRegelService } from '../../service/import-regel/import-regel.service';
import { ImportRegelDto, ImportRegelFieldNames, ImportRegelFieldOrder } from '../../domain/model/import-regel.model';
import { take, takeWhile } from 'rxjs/operators';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import {
    SettingsNetzzuordnungImportDetailComponent,
} from '../settings-netzzuordnung-import-detail/settings-netzzuordnung-import-detail.component';
import { Leistungseinheit } from '../../domain/model/leistungseinheit';
import { ImportNzIdWizardComponent } from '../../nzId-import-wizard/import-wizard/import-nz-id-wizard.component';
import { ImportWizardDialogService } from '../../ea-import-wizard/service/import-wizard-dialog.service';

export class ImportRegelRow {
    constructor(public rulename: string, public value: number, public key: keyof ImportRegelDto) {
    }
}

@Component({
    selector: 'tnb-settings-netzzuordnung-import',
    templateUrl: './settings-netzzuordnung-import-page.component.html',
    styleUrls: [
        './settings-netzzuordnung-import-page.component.scss',
    ],
    standalone: false,
})
export class SettingsNetzzuordnungImportPageComponent implements OnInit, OnDestroy {
    private importRegelService = inject(ImportRegelService);
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private dialogService = inject(ImportWizardDialogService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public importRegelList = new MatTableDataSource<ImportRegelRow>();

    public importRegeln: ImportRegelDto | null;

    public columnsToDisplay = [
        'rulename',
        'value',
    ];

    private componentDestroyed: boolean;

    constructor() {
        this.importRegeln = null;
        this.componentDestroyed = false;
        this.importRegelList.data;
    }

    ngOnInit(): void {
        this.reloadImportRegeln();
        this.westnetzSidenavService.closeRightnav$.pipe(
            takeWhile(() => !this.componentDestroyed),
        ).subscribe({
            next: _v => this.reloadImportRegeln(),
        });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

    public applyFilter(_event: Event) {
    }

    public editImportRegel() {
        this.westnetzSidenavService.openRightnav(SettingsNetzzuordnungImportDetailComponent);
    }

    private reloadImportRegeln() {
        this.importRegelService.getImportRegeln().pipe(
            take(1),
        ).subscribe({
            next: (v) => this.updateImportRegeln(v),
        });
    }

    private updateImportRegeln(dto: ImportRegelDto): void {
        this.importRegeln = dto;
        const importRegelList: Array<ImportRegelRow> = [];
        ImportRegelFieldOrder.forEach((key) => {
            const item = new ImportRegelRow(ImportRegelFieldNames[key], dto[key], key);
            importRegelList.push(item);
        });
        this.importRegelList.data = importRegelList;
        this.changeDetectorRef.markForCheck();
    }

    protected readonly Leistungseinheit = Leistungseinheit;

    public openNzIdImportWizard() {
        this.dialogService.openImportWizard(ImportNzIdWizardComponent);
    }
}
